import { AfterViewInit, Component, inject, OnInit } from '@angular/core';
import { EventOriginEnum, NavigateToEnum } from '@app/core/enums/analytics/analytics-value.enum';
import { EntityTypeEnum } from '@app/core/enums/entity-type.enum';
import { IRelatedMeeting, RelatedMeeting } from '@app/core/model/entities/meeting/meeting';
import { MeetingsService } from '@app/features/main/views/meetings/meetings.services';
import { EntityFieldBuilder } from '@app/shared/components/fields/entity-field-builder/abstract-entity-field-builder';

@Component({
  selector: 'meeting-field-builder',
  templateUrl: './meeting-field-builder.component.html',
  styleUrls: ['../entity-field-builder.component.scss'],
  standalone: false
})
export class MeetingFieldBuilderComponent extends EntityFieldBuilder<IRelatedMeeting, RelatedMeeting> implements OnInit, AfterViewInit {
  protected meetingsService = inject(MeetingsService);

  /**
   * Instantiate a new RelatedMeeting
   * @param relatedMeeting Object to instantiate
   * @return RelatedMeeting
   */
  public newRelatedEntity(relatedMeeting: IRelatedMeeting): RelatedMeeting {
    return new RelatedMeeting(relatedMeeting);
  }

  /**
   * Navigate to the main sheet of the related Meeting
   */
  public async navigateToEntitySheet(): Promise<void> {
    if (!this.isSingleEntityControl(this.form.controls.field)) return;

    this.analyticsService.trackNavigationEvent(
      EventOriginEnum.FIELD_CLICK,
      NavigateToEnum.SHEET,
      EntityTypeEnum.MEETING,
      this.form.controls.field.value.id
    );
    await this.meetingsService.navigateToMeetingSheet(this.form.controls.field.value.id);
  }
}
